import { schema } from "normalizr";
import { arrayOfAttachments } from "./schema.attachments.jsx";
import { arrayOfLabels } from "./schema.labels.jsx";

const projectTemplateElement = new schema.Entity(`projectTemplateElements`);
const arrayOfProjectTemplateElements = [projectTemplateElement];

projectTemplateElement.define({
  labels: arrayOfLabels,
  attachments: arrayOfAttachments,
});

export { projectTemplateElement, arrayOfProjectTemplateElements };
